import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useSite } from "../Sites/Provider";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import Fields from "./Fields";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FilterList } from "@mui/icons-material";
import { useOdooInvoices } from "./provider";
import { useCompany } from "../Companies/Provider";
import { useAuth } from "../../services/auth";
import { useParams } from "react-router-dom";

const GridGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 350px);
`;

const FilterForm = ({
  form,
  formSubmitted,
  setFormSubmitted,
  siteId,
  setSiteId,
}) => {
  const theme = useTheme();
  const { role, adminOn } = useAuth();
  const { name } = useParams();

  const [error, setError] = useState(null);
  const [failure, setFailure] = useState(false);
  const [companyId, setCompanyId] = useState();
  const [loading, setLoading] = useState(false);

  const {
    state: { Names: sites, selected: SiteInfo },
    fetchSiteNames: fetchSites,
  } = useSite();

  const {
    state: { page, perPage, pageEntries, perPageEntries },
    fetchList,
    fetchJournalList,
    fetchListOdooInvoicesReport,
  } = useOdooInvoices();

  const {
    state: { Names: companies },
    fetchNames: fetchCompanies,
  } = useCompany();

  useEffect(() => {
    if (role === "Admin") fetchCompanies();
  }, [fetchCompanies, role]);

  useEffect(() => {
    if (role === "Admin" || role === "Company") fetchSites(companyId, 0);
  }, [companyId, role]);

  useEffect(() => {
    form.setValue("isFailure", failure);
  }, [failure, form]);
  useEffect(() => {
    if (role === "Company") setCompanyId(adminOn?.id);
    else if (role === "Site") {
      setCompanyId(SiteInfo?.companyId);
    }
  }, [role, adminOn, setCompanyId, SiteInfo, form]);

  const getData = (name) => {
    switch (name) {
      case "companyId":
        return companies;
      case "siteId":
        // return [{ id: 0, name: "All" }, ...sites];
        return sites;
      default:
        return [];
    }
  };
  useEffect(() => {
    if (role === "Company") form.setValue("companyId", adminOn?.id);
  }, [role, form, adminOn]);
  useEffect(() => {
    if (role === "Site") form.setValue("siteId", adminOn?.id);
  }, [role, form, adminOn]);
  useEffect(() => {
    if (role === "Site") form.setValue("companyId", SiteInfo?.companyId);
  }, [role, form, adminOn, SiteInfo]);
  const onSubmit = async (values) => {
    setFormSubmitted(true);
    setError(null);
    if (name !== "OdooInvoicesReport") {
      if (values.siteId || values.siteId === 0) {
        setLoading(true);
        try {
          if (name === "OdooInvoices") {
            await fetchList(values, page, perPage);
          } else {
            await fetchJournalList(values, pageEntries, perPageEntries);
          }
        } catch (error) {
          setError(error.errors?.message || "An error occurred");
        } finally {
          setLoading(false);
        }
      } else {
        setError("You should select a site");
      }
    } else if (name === "OdooInvoicesReport") {
      setLoading(true);
      try {
        await fetchListOdooInvoicesReport(values, page, perPage);
      } catch (error) {
        setError(error.errors?.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    }
  };

 

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} noValidate>
      <Box mb={1}>
        {error && (
          <Alert severity="error" sx={{ width: "fit-content" }}>
            {error}
          </Alert>
        )}
      </Box>
      <Box
        sx={{
          background: "#f7f9fb",
          padding: "10px 20px",
          width: "90%",
          mb: 3,
        }}
      >
        <GridGroup>
          {(role === "Company" || role === "Site") && (
            <>
              <Box
                sx={{
                  background: "#f7f9fb",
                  width: "70%",
                }}
              >
                <span style={{ fontSize: "12px" }}>Company Name</span>
                <Box
                  sx={{
                    borderBottom: "1px solid gray",
                    width: "290px",
                    borderRadius: "8px",
                    textAlign: "center",
                    marginRight: "20px",
                    marginTop: "15px",
                  }}
                >
                  {role === "Company"
                    ? adminOn?.companyName
                    : SiteInfo?.company?.companyName}
                </Box>
              </Box>
            </>
          )}
          {role === "Site" && (
            <>
              <Box
                sx={{
                  background: "#f7f9fb",
                  width: "70%",
                }}
              >
                <span style={{ fontSize: "12px" }}>Site Name</span>
                <Box
                  sx={{
                    borderBottom: "1px solid gray",
                    width: "290px",
                    borderRadius: "8px",
                    textAlign: "center",
                    marginRight: "20px",
                    marginTop: "15px",
                  }}
                >
                  {adminOn?.siteName}
                </Box>
              </Box>
            </>
          )}
          {Fields.map((f, index) => (
            <React.Fragment key={index}>
              {f.select ? (
                <FormControl
                  sx={{
                    minWidth: 120,
                    marginBottom: name !== "OdooInvoicesReport" ? "20px" : 0,
                    display:
                      (role !== "Admin" && f.name === "companyId") ||
                      (role === "Site" && f.name === "siteId") ||
                      (f.name === "siteId" && name === "OdooInvoicesReport")
                        ? "none"
                        : null,
                  }}
                >
                  <span style={{ fontSize: "12px" }}>{f.label}</span>
                  <Select
                    value={
                      f.name === "siteId" ? (siteId ?? "") : (companyId ?? "")
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      form.setValue(f.name, value);
                      if (f.name === "companyId") setCompanyId(value);
                      if (f.name === "siteId") setSiteId(value);
                    }}
                    inputProps={{
                      "aria-label": "Without label",
                      autoFocus: true,
                    }}
                    sx={{
                      fontSize: "12px",
                      width: "300px",
                      height: "40px",
                      marginTop: "4px",
                    }}
                  >
                    {getData(f.name).map((site) => (
                      <MenuItem key={site.id} value={site.id}>
                        {site.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : f.checkbox ? (
                <Box
                  sx={{
                    display: name === "OdooInvoicesReport" ? "none" : "",
                  }}
                >
                  <Checkbox
                    checked={failure}
                    onChange={(e) => setFailure(e.target.checked)}
                  />
                  <span style={{ fontSize: "12px" }}>Failure</span>
                </Box>
              ) : (
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={"de"}
                >
                  <div>
                    <div style={{ fontSize: "12px", marginBottom: "2px" }}>
                      {f.label}
                    </div>
                    <DateTimePicker
                      onChange={(date) => form.setValue(f.name, date)}
                      sx={{ width: theme.dimensions.width }}
                      inputProps={{
                        ...form.register(f.name),
                        required: true,
                      }}
                      type="datetime-local"
                      slotProps={{
                        textField: {
                          required: f.required,
                          helperText: <p style={{ color: "#d32f2f" }}></p>,
                          size: "small",
                        },
                      }}
                    />
                  </div>
                </LocalizationProvider>
              )}
            </React.Fragment>
          ))}
        </GridGroup>
        <Box display={"flex"} justifyContent={"end"} mt={2}>
          <Button
            className="b"
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              backgroundColor: theme.color.blackBackground,
              color: "white",
              "&:hover": { background: `${theme.color.blackBackground}` },
              textTransform: "capitalize",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              <FilterList />
            )}
            <span>Filter</span>
          </Button>
        </Box>
      </Box>
    </form>
  );
};

export default FilterForm;
